const libri = document.getElementById('Details-HeaderMenu-1');
const edSpeciali = document.getElementById('Details-HeaderMenu-2');
const news = document.getElementById('Details-HeaderMenu-4');
const chiSiamo = document.getElementById('Details-HeaderMenu-5');

libri.addEventListener("mouseover", (event)=>{
    libri.setAttribute("open","");
});
libri.addEventListener("mouseout", (event)=>{
    libri.removeAttribute("open");
});

edSpeciali.addEventListener("mouseover", (event)=>{
    edSpeciali.setAttribute("open","");
});
edSpeciali.addEventListener("mouseout", (event)=>{
    edSpeciali.removeAttribute("open");
});

news.addEventListener("mouseover", (event)=>{
    news.setAttribute("open","");
});
news.addEventListener("mouseout", (event)=>{
    news.removeAttribute("open");
});

chiSiamo.addEventListener("mouseover", (event)=>{
    chiSiamo.setAttribute("open","");
});
chiSiamo.addEventListener("mouseout", (event)=>{
    chiSiamo.removeAttribute("open");
});